import axios from 'axios'
import moment from 'moment'
import Utils from '../services/Utils'

axios.defaults.timeout = 600000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
axios.defaults.storageApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].storage

export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    getStrings(callback) {
        if (window.appCache && window.appCache.strings) {
            return Utils.processResponse(
                {
                    request: {
                        response: JSON.stringify({
                            success: true,
                            data: window.appCache.strings,
                        }),
                    },
                },
                callback,
            )
        }
        axios
            .get(axios.defaults.ptApiUrl + 'translations?website=1&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getEnums(callback) {
        if (window.appCache && window.appCache.enums) {
            Utils.refreshEnums(window.appCache.enums)
            return callback()
        }
        axios
            .get(axios.defaults.ptApiUrl + 'enums?pt_id=' + window.ptId + '&website=1&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                let enums = {}
                if (response.data && response.data.data) {
                    enums = response.data.data
                }
                Utils.refreshEnums(enums)
                callback()
            })
            .catch((response) => {
                Utils.refreshEnums({})
                callback()
            })
    },
    getRegisterConfig(callback) {
        if (window.appCache && window.appCache.registerConfig) {
            return Utils.processResponse(
                {
                    request: {
                        response: JSON.stringify({
                            success: true,
                            data: window.appCache.registerConfig,
                        }),
                    },
                },
                callback,
            )
        }
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'register_config?db_id=' +
                    window.ptId +
                    '&check_enable=1' +
                    (window.configType ? '&type=' + window.configType : '') +
                    (window.apiDev ? '&dev=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    register(data, callback) {
        data.pt_id = window.ptId

        axios
            .post(axios.defaults.ptApiUrl + 'register', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    updateRegister(data, callback) {
        const id = data.id
        delete data.id

        axios
            .patch(axios.defaults.ptApiUrl + 'register?pt_id=' + window.ptId + '&id=' + id + '&website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    newClientRegisterAssets(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'register_photo', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    addSubscription(data, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl +
                    'stripe_sub_create?db_id=' +
                    window.ptId +
                    (window.useCheckout ? '&checkout=1' : '') +
                    (window.useHotmart ? '&hotmart=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    cancelSubscription(subscriptionId, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl +
                    'stripe_sub_cancel?paym_sub=' +
                    subscriptionId +
                    '&db_id=' +
                    window.ptId +
                    (window.useCheckout ? '&checkout=1' : '') +
                    (window.useHotmart ? '&hotmart=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getRegister(id, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'register?filter={"pt_id": ' +
                    window.ptId +
                    ',"id": ' +
                    id +
                    '}&fields=["paym_sub_status"]&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getRegisterByEmail(email, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'register?filter={"pt_id":' +
                    window.ptId +
                    ',"status":0,"email":"' +
                    email +
                    '"}&fields=["id","pt_id","email"]&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    validateRegister(id, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl + 'register_validate?id=' + id + '&pt_id=' + window.ptId + '&website=1&lng=' + window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    refuseRegister(data, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl +
                    'register_invalid?id=' +
                    data.id +
                    '&pt_id=' +
                    window.ptId +
                    '&log=' +
                    data.log +
                    '&website=1&lng=' +
                    window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    updateUser(data, callback) {
        const id = data.id
        delete data.id

        axios
            .patch(axios.defaults.ptApiUrl + 'user?pt_id=' + window.ptId + '&id=' + id + '&website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getSubscriptionPlans(data, callback) {
        const code = data.code
        const currency = data.currency
        let codeFilter = ''
        if (code) {
            codeFilter += '&code=' + code
        }
        if (currency) {
            codeFilter += '&currency=' + currency
        }
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'stripe_products?db_id=' +
                    window.ptId +
                    codeFilter +
                    (window.useCheckout ? '&checkout=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getHotmartSubscriptionPlans(data, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'promo_code?db_id=' +
                    window.ptId +
                    '&filter={"code":"' +
                    data.code +
                    '"}&check_use=1&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    validatePromoCode(data, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'promo_code?db_id=' +
                    window.ptId +
                    '&search={"code":["' +
                    data.code +
                    '"]' +
                    (data.types ? ',"type":' + JSON.stringify(data.types) : '') +
                    '}&check_use=1&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    sendRegisterPayment(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'register_payment?website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    newClient(data, callback) {
        data.pt_id = parseFloat(window.ptId)
        data.paym_pri = 'price_1K9toaHimNUi5jcY1VIJEso8'
        data.payday = '2040-12-12'
        data.feedback_day = '2040-12-12'

        axios
            .post(axios.defaults.ptApiUrl + 'user', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getRequest(data, callback) {
        if (data.url.indexOf('https://') === -1) {
            data.url = axios.defaults.ptApiUrl + data.url
        }
        axios
            .get(data.url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                callback({
                    success: true,
                    data: response.data,
                    item: data.item,
                })
            })
            .catch((response) => {
                callback({
                    success: false,
                    data: [],
                    item: data.item,
                })
            })
    },
    refreshHotmartConnections(callback) {
        axios
            .post(
                axios.defaults.ptApiUrl + 'hotmart/connect?pt_id=' + window.ptId + '&website=1&lng=' + window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    createOrderVW(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'vw/order/create?pt_id=' + window.ptId + '&website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getPacks(data, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'pack?db_id=' +
                    window.ptId +
                    '&query=[{"f":"status","q":0,"v":0,"n":1},' +
                    (data.category || data.category === 0 ? '{"f":"category","q":0,"v":' + data.category + ',"n":1},' : '') +
                    (data.gateway ? '{"f":"gateway","q":0,"v":' + data.gateway + ',"n":1},' : '') +
                    '{"f":"start_date","d":1,"q":4,"v":"\'now\'","x":1,"n":1},{"f":"end_date","d":1,"q":5,"v":"\'now\'","x":1,"n":0}]' +
                    (data.code ? '&promo_code=' + data.code : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: this.getAuthorization(),
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getBookingSchedule(callback) {
        const startDate = moment().format('YYYY-MM-DD')
        const endDate = moment().add(200, 'days').format('YYYY-MM-DD')
        axios
            .get(axios.defaults.ptApiUrl + 'booking_schedule', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization(),
                },
                params: {
                    query:
                        '[{"f":"pt_id","q":0,"v":' +
                        window.ptId +
                        ',"n":1},{"f":"start_date","d":1,"q":5,"v":"' +
                        startDate +
                        '","n":1},{"f":"end_date","d":1,"q":4,"v":"' +
                        endDate +
                        '","n":1},{"f":"status","q":1,"v":"deleted","n":0}]',
                    lng: window.language,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    async createOrderEuPago(data, callback) {
        const getAuthorization = async () => {
            try {
                const eupagoLoginData = JSON.parse(process.env.VUE_APP_EUPAGO)
                const authorizationPayload = eupagoLoginData ? eupagoLoginData[window.ptId.toString()] : null
                if (authorizationPayload) {
                    const res = await axios.post('https://api.mkgest.services/v1/token/', authorizationPayload, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                    if (res.data && res.data.access) {
                        return `Bearer ${res.data.access}`
                    }
                }
            } catch {}
            return null
        }
        const authorization = await getAuthorization()
        axios
            .post('https://api.mkgest.services/v1/eupago/cofidis-external/', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authorization,
                },
            })
            .then((response) => {
                callback({
                    success: true,
                    data: response.data,
                })
            })
            .catch((response) => {
                callback({
                    success: false,
                    data: null,
                    message:
                        response && response.response && response.response.data && response.response.data.message
                            ? response.response.data.message
                            : window.strings['common_error'],
                })
            })
    },
    createOrderSequra(data, authorization, callback) {
        const authenticationError = window.strings['sequra_authentication_error'] || window.strings['common_error']
        if (!authorization) {
            return callback({
                success: false,
                data: null,
                message: authenticationError,
            })
        }
        axios
            .post('https://api.mkgest.services/v1/sequra/external/create/', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authorization,
                },
            })
            .then((response) => {
                callback({
                    success: response && response.data && response.data.status === 'success' ? true : false,
                    data: response && response.data ? response.data : null,
                    message: response && response.data && response.data.message ? response.data.message : window.strings['common_error'],
                })
            })
            .catch((error) => {
                callback({
                    success: false,
                    data: null,
                    message:
                        error && error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : window.strings['common_error'],
                })
            })
    },
}
